export default class ConversationTopicFirestoreDto {
    id = '';
	tenantId = '';
	name = '';
	actionRequiredCount = 0;
	isEnabled = false;
	isPublic = false;
}